import React, { Component } from 'react';
import Ribbon from '../../components/Ribbon';
import { showModal } from '../../actions/modal';
import { connect } from 'react-redux';
import Translator from "../../requests/apa/Translator";
import RibbonsUtil from '../../utils/RibbonsUtil';
import Utils from "../../utils/Utils";

class SocialSeen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seen: [],
        }
    }

    resolveUserLogin() {
      let userType = 'anonymous';
      if (this.props.user.isLoggedIn && this.props.user.superhighlight) {
        userType = this.props.user.superhighlight.join();
      }
      return userType;
    }

    getSeenLastCarrousel() {
      const links = this.props.getLinks();
      const node = links.miscontenidos || 'micontenido';
      const userStatus = this.resolveUserLogin();
      const ribbons_show_delete_button = Utils.getRegionaliazedMetadata('ribbons_show_delete_button', '{"default":{"lastseen":{"enable":true,"type":["Actividad-reciente","actividadreciente","Continua-viendo","continuaviendo","Recien-visto"]},"favorite":{"enable":true,"type":["Por-ver","porver","porver-live","porver-vod"]}}}');
      const last_seen_info = ribbons_show_delete_button.lastseen;
        const rb = new RibbonsUtil();
        rb.getUserMiddlewareRibbons(
          node,
          userStatus,
          resp => {
            if(resp && Array.isArray(resp.components)){
              for (let i = 0; i < resp.components.length; i++) {
                if(last_seen_info.enable && last_seen_info.type.includes(resp.components[i].id)) {
                  this.setState({seen: resp.components[i].items});
                  i = resp.components.length;
                }
              }
            }
          },
          this.props.user.session_userhash || ''
        );

    }

    componentDidMount() {
      this.getSeenLastCarrousel();
    }

    render() {
        if(this.state.seen.length === 0) {
          return (
            <div className="seens" style={{ padding: '15px 0 0', margin: '0 0 8px 10px', }}>
              <div
                style={{
                  color: '#c7c7c7',
                  fontSize: 22,
                  paddingBottom: 10,
                }}
              >
                { this.props.translations.get('social_profile_seen_title', 'Recién Vistos') }
              </div>
              <div className={'card'} style={{ width: '100%' }}>
                <a
                  className={'focusable'}
                  style={{
                    color: '#c7c7c7',
                    fontSize: 18,
                    fontWeight: 'lighter',
                    textDecoration: 'none',
                  }}
                  href={'javascript:void(0)'}
                  dangerouslySetInnerHTML={{ __html: Translator.get('own_social_profile_empty_seen_msg') }}
                />
              </div>
            </div>
          )
        }


        const { seen } = this.state;

        return(<div className="seens">
        	<Ribbon
              title={this.props.translations.get('social_profile_seen_title', 'Recién Vistos')}
              type="landscape"
              items={ seen }
              setMetricsEvent={this.props.setMetricsEvent}
              carruselTitle={'Recién Vistos'}
              hideTitles={ true }
            />
        </div>);
    }

}

const mapStateToProps = (state) => {
    return { user: state.user }
}

export default connect(mapStateToProps, { showModal })(SocialSeen);



// WEBPACK FOOTER //
// ./src/containers/Social/SocialSeen.jsx